function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 27 24"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21.2143 14.373V19.1191C21.2143 20.2958 20.7899 21.3018 19.9411 22.1374C19.0924 22.9729 18.0703 23.3906 16.875 23.3906H4.33929C3.14397 23.3906 2.12193 22.9729 1.27316 22.1374C0.424386 21.3018 0 20.2958 0 19.1191V6.7793C0 5.60266 0.424386 4.59659 1.27316 3.76108C2.12193 2.92557 3.14397 2.50781 4.33929 2.50781H14.9464C15.0871 2.50781 15.2026 2.55231 15.293 2.6413C15.3834 2.73029 15.4286 2.84399 15.4286 2.98242V3.93164C15.4286 4.07007 15.3834 4.18378 15.293 4.27277C15.2026 4.36176 15.0871 4.40625 14.9464 4.40625H4.33929C3.67634 4.40625 3.10882 4.63861 2.63672 5.10333C2.16462 5.56805 1.92857 6.12671 1.92857 6.7793V19.1191C1.92857 19.7717 2.16462 20.3304 2.63672 20.7951C3.10882 21.2598 3.67634 21.4922 4.33929 21.4922H16.875C17.5379 21.4922 18.1055 21.2598 18.5776 20.7951C19.0497 20.3304 19.2857 19.7717 19.2857 19.1191V14.373C19.2857 14.2346 19.3309 14.1209 19.4213 14.0319C19.5117 13.9429 19.6272 13.8984 19.7679 13.8984H20.7321C20.8728 13.8984 20.9883 13.9429 21.0787 14.0319C21.1691 14.1209 21.2143 14.2346 21.2143 14.373ZM27 1.55859V9.15234C27 9.40942 26.9046 9.6319 26.7137 9.81976C26.5229 10.0076 26.2969 10.1016 26.0357 10.1016C25.7746 10.1016 25.5485 10.0076 25.3577 9.81976L22.7059 7.20941L12.8823 16.8796C12.7818 16.9785 12.6663 17.0279 12.5357 17.0279C12.4051 17.0279 12.2896 16.9785 12.1892 16.8796L10.4715 15.1888C10.3711 15.0899 10.3209 14.9762 10.3209 14.8477C10.3209 14.7191 10.3711 14.6054 10.4715 14.5065L20.2952 4.83636L17.6434 2.22601C17.4526 2.03815 17.3571 1.81567 17.3571 1.55859C17.3571 1.30151 17.4526 1.07904 17.6434 0.891174C17.8343 0.703308 18.0603 0.609375 18.3214 0.609375H26.0357C26.2969 0.609375 26.5229 0.703308 26.7137 0.891174C26.9046 1.07904 27 1.30151 27 1.55859Z"
        })
    }));
};
export default Icon;
